import { createUseQueryHook } from '@iheartjane/react-query-utils';
import type { Nullish } from '@iheartjane/types';

import type {
  FetchAeropayBankConnectionProps,
  FetchAeropayUserProps,
} from './aeropay.api';
import { fetchAeropayBankConnection, fetchAeropayUser } from './aeropay.api';
import type { AeropayBankConnection, AeropayUser, Id } from './aeropay.types';

export const AEROPAY_BASE_KEY = 'aeropay';

interface UseAeropayUserProps extends FetchAeropayUserProps {
  janeUserId: Nullish<Id>;
}

export const aeropayQueryKeys = {
  aeropayUser: ({ janeUserId }: Pick<UseAeropayUserProps, 'janeUserId'>) => [
    AEROPAY_BASE_KEY,
    'user',
    janeUserId,
  ],
  bankConnection: () => [AEROPAY_BASE_KEY, 'bankConnection'],
};

export const useAeropayUser = createUseQueryHook<
  UseAeropayUserProps,
  AeropayUser | null
>(
  fetchAeropayUser,
  aeropayQueryKeys.aeropayUser,
  ({ janeUserId, jwt }) => !!jwt && !!janeUserId
);

export const useAeropayBankConnection = createUseQueryHook<
  FetchAeropayBankConnectionProps,
  AeropayBankConnection
>(
  fetchAeropayBankConnection,
  aeropayQueryKeys.bankConnection,
  ({ jwt }) => !!jwt
);
